export default "__VITE_ASSET__qA7T$pkg__"